import * as Redux from 'redux';
import { HashMap } from '../constants';
import { SimManagementError } from '../models/Errors';
import { CommandTypesPayload } from '../models/state/commandTypeState';
import {
  ENSURE_COMMAND_TYPES,
  LOAD_COMMAND_TYPES,
  LOAD_COMMAND_TYPES_FAILURE,
  LOAD_COMMAND_TYPES_PENDING,
  LOAD_COMMAND_TYPES_SUCCESS,
} from './actionTypes';
import { Action } from './commonActions';

/**
 * Action which loads the available commands from the server if required.
 * @param payload A comma-separated list of identifiers for the currently selected stock
 */
export function ensureCommandTypes(): Redux.Action {
  return {
    type: ENSURE_COMMAND_TYPES,
  };
}

/**
 * Action which loads the available commands from the server.
 * @param payload A comma-separated list of identifiers for the currently selected stock
 */
export function loadCommandTypes(): Redux.Action {
  return {
    type: LOAD_COMMAND_TYPES,
  };
}

/**
 * Action which sets the load status of the command types to pending.
 * @param payload A comma-separated list of identifiers for the currently selected stock
 */
export function loadCommandTypesPending(): Redux.Action {
  return {
    type: LOAD_COMMAND_TYPES_PENDING,
  };
}

/**
 * Action which handles when the command types are successfully loaded.
 * @param commandTypes The command types payload
 */
export function loadCommandTypesSuccess(payload: CommandTypesPayload): Action<CommandTypesPayload> {
  return {
    type: LOAD_COMMAND_TYPES_SUCCESS,
    payload,
  };
}

/**
 * Action which handles when there is a failure to load the selected company.
 * @param selectedStockIds A comma-separated list of identifiers for the currently selected stock
 * @param error The error.
 */
export function loadCommandTypesFailure(error: SimManagementError): Action<SimManagementError> {
  return {
    error: true,
    type: LOAD_COMMAND_TYPES_FAILURE,
    payload: error,
  };
}
